import React from 'react';
import { InstagramIcon, MessageCircleIcon, FacebookIcon } from 'lucide-react';
export function FooterSection() {
  return <footer className="bg-dark pt-16 pb-8 border-t border-dark-card" data-id="element-69">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-70">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-71">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start" data-id="element-72">
            <img src="https://cdn.shopify.com/s/files/1/0976/6528/6457/files/althypro_400_x_120_px_blanco.png?v=1768000809" alt="Althypro Logo" className="h-10 w-auto mb-6" data-id="element-73" />
            <p className="text-gray-400 text-sm text-center md:text-left max-w-xs" data-id="element-74">
              Suplementos premium con ingredientes patentados Fórmulas claras,
              estándares reales y resultados consistentes.
            </p>
          </div>

          {/* Links & Social */}
          <div className="flex flex-col items-center md:items-center" data-id="element-75">
            <h4 className="text-white font-bold mb-6" data-id="element-76">Siguenos y conoce mas de nosotros</h4>
            <div className="flex space-x-4" data-id="element-77">
              <a href="https://www.instagram.com/althypro/" className="w-10 h-10 rounded-full bg-dark-surface flex items-center justify-center text-gray-400 hover:text-green-brand hover:bg-green-brand/10 transition-colors" data-id="element-78">
                <InstagramIcon className="w-5 h-5" data-id="element-79" />
              </a>
              <a href="https://www.facebook.com/p/Althypro-100095128923096/" className="w-10 h-10 rounded-full bg-dark-surface flex items-center justify-center text-gray-400 hover:text-green-brand hover:bg-green-brand/10 transition-colors" data-id="element-80">
                <FacebookIcon className="w-5 h-5" data-id="element-81" />
              </a>
              <a href="https://wa.me/523322082356?text=Hola%2C%20vengo%20de%20la%20p%C3%A1gina%20de%20Myochiro-Pro%20y%20tengo%20algunas%20dudas.%20%C2%BFMe%20podr%C3%ADan%20orientar%3F" className="w-10 h-10 rounded-full bg-dark-surface flex items-center justify-center text-gray-400 hover:text-green-brand hover:bg-green-brand/10 transition-colors" data-id="element-82">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className="w-5 h-5 fill-current" data-id="element-83">
                  <path d="M16 .4C7.4.4.4 7.4.4 16c0 2.8.7 5.4 2.1 7.8L.2 31.8l8.2-2.2c2.3 1.2 4.9 1.8 7.6 1.8 8.6 0 15.6-7 15.6-15.6S24.6.4 16 .4zm0 28.4c-2.4 0-4.7-.7-6.7-1.9l-.5-.3-4.9 1.3 1.3-4.8-.3-.5C3.6 20.6 3 18.4 3 16 3 9.4 8.4 4 15 4s12 5.4 12 12-5.4 12.8-11 12.8zm6.3-9.5c-.3-.1-1.8-.9-2.1-1-.3-.1-.5-.1-.7.1s-.8 1-1 1.2-.3.2-.6.1c-.3-.1-1.4-.5-2.7-1.7-1-1-1.7-2.2-1.9-2.5s0-.4.1-.6c.1-.1.3-.3.4-.5.1-.1.2-.3.3-.5.1-.2 0-.4 0-.5s-.7-1.7-1-2.3c-.2-.5-.5-.4-.7-.4h-.6c-.2 0-.5.1-.8.4s-1 1-1 2.4 1 2.8 1.2 3 .2.3.4.5c.3.3 1.6 2.4 3.9 3.3.6.3 1.1.4 1.5.5.6.2 1.1.2 1.5.1.5-.1 1.8-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.1-.3-.2-.6-.3z" data-id="element-84" />
                </svg>
              </a>
            </div>
          </div>

          {/* Payments */}
          <div className="flex flex-col items-center md:items-end" data-id="element-85">
            <h4 className="text-white font-bold mb-6" data-id="element-86">Pago Seguro</h4>
            <div className="flex flex-wrap justify-center md:justify-end gap-3 text-gray-500 text-sm font-medium" data-id="element-87">
              <span className="bg-dark-surface px-3 py-1 rounded" data-id="element-88">
                Visa/Mastercard
              </span>
              <span className="bg-dark-surface px-3 py-1 rounded" data-id="element-89">
                Mercado Pago
              </span>
              <span className="bg-dark-surface px-3 py-1 rounded" data-id="element-90">PayPal</span>
            </div>
          </div>
        </div>

        <div className="border-t border-dark-card pt-8 text-center" data-id="element-91">
          <p className="text-xs text-gray-500 mb-4 max-w-3xl mx-auto leading-relaxed" data-id="element-92">
            Descargo de responsabilidad: Este producto no es un medicamento. El
            consumo de este producto es responsabilidad de quien lo recomienda y
            de quien lo usa.
          </p>
          <p className="text-xs text-gray-600" data-id="element-93">
            &copy; {new Date().getFullYear()} Althypro. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}